import { apiUrlFor, isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_ADMIN_AI=true in .env.local for the local API.
export const ADMIN_AI_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_ADMIN_AI
);
export const ADMIN_AI_API_URL = apiUrlFor(
  process.env.REACT_APP_LOCAL_API_ADMIN_AI
);
